module.exports = __webpack_public_path__ + "img/link.8326c8f2.svg";